let SHOP = Shopify.shop || Shopify.Checkout.apiHost;

// Details for Storefront API.
const storefrontAccessToken = {
    dev: '337d93f5c8b0951dad213bb639f1f9bd',
    prod: '18f3de09781d20bf0d445e980bcec2ec'
};

const shopType = SHOP.indexOf('-dev') > -1 ? 'dev' : 'prod';
const HOSTNAME = SHOP;

const baseUrl = window.location.host

export const getHostName = HOSTNAME;

function getAccessToken(type) {
    return type == 'dev' ? storefrontAccessToken.dev : storefrontAccessToken.prod;
}

export const storefrontRequestConfig = {
    headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': getAccessToken(shopType)
    }
};

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};


// Middleware integrations
export function getAlgoliaIndex(sort, prefix) {
  if (sort.sort_by == 'manual') {
      sort.sort_by = ''
      sort.dir = ''
  }
  if (shopType == 'dev') {
      return `${prefix}products${sort.sort_by ? '_' + sort.sort_by : ''}${sort.dir ? '_' + sort.dir : ''}`
  } else {
      return `${prefix}products${sort.sort_by ? '_' + sort.sort_by : ''}${sort.dir ? '_' + sort.dir : ''}`
  }
}

const siblingsUrl = {
    'dev': `https://shopifyonionnavapp-dev.testarc.com.au/api/2021-06/products/get-by-ids?shop=${HOSTNAME}`,
    'prod': `https://shopifyonionnavapp.testarc.com.au/api/2021-06/products/get-by-ids?shop=${HOSTNAME}`
};

export function getSiblingsUrl() {
    return siblingsUrl[shopType];
}

const prescriptionAppUrl = {
    // 'dev': `https://shopifyprescriptions-dev.testarc.com.au/api/2021-01/prescriptions/post?shop=${HOSTNAME}`,
    // 'prod': `https://shopifyprescriptions.testarc.com.au/api/2021-01/prescriptions/post?shop=${HOSTNAME}`
    'dev': `https://${baseUrl}/apps/1001prescriptions/api/prescriptions?shop=${HOSTNAME}&variant_id=`,
    'prod': `https://${baseUrl}/apps/prescriptionsapp/api/prescriptions?shop=${HOSTNAME}&variant_id=`
};

export function getPrescriptionUrl() {
    return prescriptionAppUrl[shopType];
};

const prescriptionUploadUrl = {
    'dev': `https://${baseUrl}/apps/1001prescriptions/api/2021-01/prescriptions/upload?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/prescriptionsapp/api/2021-01/prescriptions/upload?shop=${HOSTNAME}`
};

export function getPrescriptionUploadUrl() {
    return prescriptionUploadUrl[shopType];
};

const brandsListUrl = {
    'dev': `https://${baseUrl}/apps/optomatedev/api/2021-01/products/brands?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/products/brands?shop=${HOSTNAME}`
};

export function getBrandsListUrl() {
    return brandsListUrl[shopType];
};

const branchDataUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/appointments/get-metadata?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/appointments/get-metadata?shop=${HOSTNAME}`
};

export function getBranchDataUrl() {
    return branchDataUrl[shopType];
};

const appointmentDataUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/appointments/get-available?shop=${HOSTNAME}&branch=`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/appointments/get-available?shop=${HOSTNAME}&branch=`
};

export function getAppointmentDataUrl() {
    return appointmentDataUrl[shopType];
};

const appointmentCreateUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/appointments/create?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/appointments/create?shop=${HOSTNAME}`
};

export function getAppointmentCreateUrl() {
    return appointmentCreateUrl[shopType];
};

const fittingBoxApiKey = {
    'dev': 'L3eCRRe6EgNDxMsv5vdeeeHyJEv8leFCQSRprKf1',
    'prod': 'L3eCRRe6EgNDxMsv5vdeeeHyJEv8leFCQSRprKf1'
};

export function getFittingBoxApiKey() {
    return fittingBoxApiKey[shopType];
};

const lensPricingUrl = {
    'dev': `https://${baseUrl}/apps/lensdev/api/cart/rules/check?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/lensapp/api/cart/rules/check?shop=${HOSTNAME}`
};

export function getlensPricingUrl() {
    return lensPricingUrl[shopType];
};

const dotDigitalContactEndpointUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/dotdigital/contact-us?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/dotdigital/contact-us?shop=${HOSTNAME}`
};
const dotDigitalRepairEndpointUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/dotdigital/contact/glasses-repair?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/dotdigital/contact/glasses-repair?shop=${HOSTNAME}`
};
const dotDigitalReplaceEndpointUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/dotdigital/contact/lens-replacement?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/dotdigital/contact/lens-replacement?shop=${HOSTNAME}`
};

export function getDotDigitalContactEndpointUrl() {
    return dotDigitalContactEndpointUrl[shopType];
};
export function getDotDigitalRepairEndpointUrl() {
    return dotDigitalRepairEndpointUrl[shopType];
};
export function getDotDigitalReplaceEndpointUrl() {
    return dotDigitalReplaceEndpointUrl[shopType];
};

const customerRegisterUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/customer?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/customer?shop=${HOSTNAME}`
};

export function getCustomerRegisterUrl() {
    return customerRegisterUrl[shopType];
};

const customerRegistrationFormUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/optomate/patient?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/optomate/patient?shop=${HOSTNAME}`
};

export function getCustomerRegistrationFormUrl() {
    return customerRegistrationFormUrl[shopType];
};

const footerNewsletterEndpointUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/2021-01/dotdigital/email-subscription?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/2021-01/dotdigital/email-subscription?shop=${HOSTNAME}`
};

export function getFooterNewsletterEndpointUrl() {
    return footerNewsletterEndpointUrl[shopType];
};


const siblingEndpointUrl = {
    'dev': `https://${baseUrl}/apps/optomateuat/api/product/[PRODUCT_ID]/siblings?shop=${HOSTNAME}`,
    'prod': `https://${baseUrl}/apps/optomateapp/api/product/[PRODUCT_ID]/siblings?shop=${HOSTNAME}`
};

export function getSiblingEndpointUrl() {
    return siblingEndpointUrl[shopType];
};